import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { Loader2, CheckCircle, XCircle } from 'lucide-react';
import { handleInstagramCallback } from '../modules/social/services/instagramService';

/**
 * Página de callback do OAuth do Instagram
 * URL: /instagram-callback
 */
const InstagramCallbackPage: React.FC = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [status, setStatus] = useState<'processing' | 'success' | 'error'>('processing');
  const [message, setMessage] = useState('Processando autenticação...');

  useEffect(() => {
    const processCallback = async () => {
      const error = searchParams.get('error');
      
      if (error) {
        setStatus('error');
        setMessage('Acesso negado. Você cancelou a autorização.');
        return;
      }

      try {
        const code = await handleInstagramCallback();
        
        if (code) {
          // Salva o code para trocar por access_token no backend
          sessionStorage.setItem('instagram_auth_code', code);
          setStatus('success');
          setMessage('Instagram conectado com sucesso!');
          
          // Redireciona após 2 segundos
          setTimeout(() => {
            navigate('/admin/profile?instagram=connected');
          }, 2000);
        } else {
          setStatus('error');
          setMessage('Erro ao processar autenticação. Tente novamente.');
        }
      } catch (err) {
        console.error('Instagram callback error:', err);
        setStatus('error');
        setMessage('Erro inesperado. Tente novamente.');
      }
    };

    processCallback();
  }, [searchParams, navigate]);

  return (
    <div className="min-h-screen bg-brand-midnight flex items-center justify-center">
      <div className="text-center p-8">
        {status === 'processing' && (
          <>
            <Loader2 className="w-16 h-16 text-pink-500 animate-spin mx-auto mb-4" />
            <p className="text-white text-lg">{message}</p>
          </>
        )}
        
        {status === 'success' && (
          <>
            <CheckCircle className="w-16 h-16 text-green-500 mx-auto mb-4" />
            <p className="text-white text-lg">{message}</p>
            <p className="text-gray-400 text-sm mt-2">Redirecionando...</p>
          </>
        )}
        
        {status === 'error' && (
          <>
            <XCircle className="w-16 h-16 text-red-500 mx-auto mb-4" />
            <p className="text-white text-lg">{message}</p>
            <button
              onClick={() => navigate('/admin/profile')}
              className="mt-4 px-6 py-2 bg-white text-gray-900 rounded-lg font-bold"
            >
              Voltar ao Perfil
            </button>
          </>
        )}
      </div>
    </div>
  );
};

export default InstagramCallbackPage;
